import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RealmRoles, User } from '../types';

export interface AuthState {
    user: User | null;
    realmRoles: Array<RealmRoles>;
}

export const authInitialState: AuthState = {
    user: null,
    realmRoles: [],
};

const authSlice = createSlice({
    name: 'auth',
    initialState: authInitialState,
    reducers: {
        setUser: (state, { payload }: PayloadAction<{ user: User }>) => {
            state.user = payload.user;
        },
        setRealmRoles: (
            state,
            { payload }: PayloadAction<{ roles: Array<RealmRoles> }>,
        ) => {
            state.realmRoles = payload.roles;
        },
        unsetUser: (state) => {
            state.user = null;
        },
    },
});

export const { setUser, setRealmRoles, unsetUser } = authSlice.actions;

export const authReducer = authSlice.reducer;

export const authSelector = (state: { auth: AuthState }) => state.auth;
